/* import __COLOCATED_TEMPLATE__ from './answer-bot-editor.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();